import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["riskBucketSelect", "clientSelect"]
  static values = { userClientId: String }

  connect() {
    console.log("UserResponsibilityMatricesFilter controller conectado")
    
    // Aguarda um pouco para garantir que o Select2 foi inicializado
    setTimeout(() => {
      this.loadInitialOptions()
    }, 100)
  }

  loadInitialOptions() {
    if (!this.hasRiskBucketSelectTarget) {
      return
    }
    
    const $riskBucketSelect = $(this.riskBucketSelectTarget)
    const currentOptions = $riskBucketSelect.find('option').length
    
    // Se já há opções carregadas pelo servidor (mais de 2: blank + "Sem classificação"), não recarrega
    if (currentOptions > 2) {
      console.log('Opções de risk bucket já carregadas pelo servidor, não recarregando')
      return
    }
    
    // Para usuários :client, usar o userClientId
    // Para admins, verificar se há um cliente selecionado
    let clientId = this.userClientIdValue
    
    if (!clientId && this.hasClientSelectTarget) {
      const $clientSelect = $(this.clientSelectTarget)
      clientId = $clientSelect.val()
    }
    
    if (clientId) {
      console.log('Carregando opções iniciais para cliente:', clientId)
      this.fetchRiskBuckets(clientId)
    } else {
      console.log('Nenhum cliente para carregar inicialmente')
    }
  }

  updateRiskBucketOptions() {
    const $clientSelect = $(this.clientSelectTarget)
    const clientId = $clientSelect.val()
    
    console.log('Atualizando opções de perfil de consumo...')
    console.log('Client ID selecionado:', clientId)

    if (!clientId) {
      console.log('Nenhum cliente selecionado, limpando opções')
      this.clearRiskBucketOptions()
      return
    }

    this.fetchRiskBuckets(clientId)
  }

  fetchRiskBuckets(clientId) {
    if (!this.hasRiskBucketSelectTarget) {
      console.error('Risk bucket select target não encontrado')
      return
    }
    
    const $riskBucketSelect = $(this.riskBucketSelectTarget)
    
    // Obter o locale da tag HTML
    const locale = document.documentElement.lang || 'pt-BR'
    
    // Buscar os perfis de consumo disponíveis para este cliente
    fetch(`/${locale}/user_responsibility_matrices/available_risk_buckets?client_id=${clientId}`, {
      headers: {
        'Accept': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        return response.json()
      })
      .then(data => {
        console.log('Perfis de consumo disponíveis:', data)
        
        // Verificar se há erro na resposta
        if (data.error) {
          throw new Error(data.error)
        }
        
        // Verificar se risk_buckets existe
        if (!data.risk_buckets || !Array.isArray(data.risk_buckets)) {
          throw new Error('Resposta inválida do servidor')
        }
        
        const currentValue = $riskBucketSelect.val()
        const placeholder = $riskBucketSelect.data('placeholder') || 'Selecione'
        
        let options = `<option value="">${placeholder}</option>`
        
        data.risk_buckets.forEach(bucket => {
          const selected = bucket.value === currentValue ? 'selected' : ''
          options += `<option value="${bucket.value}" ${selected}>${bucket.label}</option>`
        })
        
        // Adicionar opção "Sem classificação" ao final
        const selectedNoClass = currentValue === 'Sem classificação' ? 'selected' : ''
        options += `<option value="Sem classificação" ${selectedNoClass}>Sem classificação</option>`

        $riskBucketSelect.html(options)
        $riskBucketSelect.trigger('change') // Notificar select2 da mudança
      })
      .catch(error => {
        console.error('Erro ao buscar perfis de consumo:', error)
        this.clearRiskBucketOptions()
        
        // Mostrar mensagem de erro para o usuário
        if (window.Swal) {
          window.Swal.fire({
            title: 'Erro',
            text: 'Não foi possível carregar os perfis de consumo disponíveis. Por favor, tente novamente.',
            icon: 'error'
          })
        }
      })
  }

  clearRiskBucketOptions() {
    if (!this.hasRiskBucketSelectTarget) {
      console.error('Risk bucket select target não encontrado')
      return
    }
    
    const $riskBucketSelect = $(this.riskBucketSelectTarget)
    const placeholder = $riskBucketSelect.data('placeholder') || 'Selecione'
    $riskBucketSelect.html(`<option value="">${placeholder}</option><option value="Sem classificação">Sem classificação</option>`)
    $riskBucketSelect.trigger('change')
  }
}

